/**
 * Short unit labels for admin UI (APT-001 / CL-001).
 * Prefer persisted `shortUnitId` / `short_unit_id` from the API; optional `index` is legacy fallback only.
 * API calls and routing still use UUID (`unit.id` / `unit.unitId`).
 */

export function normalizeUnitTypeLabel(raw) {
  const t = String(raw ?? "").trim();
  if (!t) return "";
  const hyphenNorm = t
    .replace(/\u2011/g, "-")
    .replace(/\u2013/g, "-")
    .replace(/\u2010/g, "-")
    .replace(/\u2012/g, "-")
    .replace(/\u2212/g, "-");
  const compact = hyphenNorm.replace(/\s+/g, "");
  if (/^co[-]?living$/i.test(compact) || /^coliving$/i.test(compact)) return "Co-Living";
  return hyphenNorm;
}

export function getDisplayUnitId(unit, index) {
  if (!unit) return "—";
  const sid = String(unit.shortUnitId ?? unit.short_unit_id ?? "").trim();
  if (sid) return sid;
  if (typeof index === "number" && index >= 0) {
    const prefix = normalizeUnitTypeLabel(unit.type) === "Co-Living" ? "CL" : "APT";
    return `${prefix}-${String(index + 1).padStart(3, "0")}`;
  }
  return "—";
}

/** Room Map / Belegungskalender headers: persisted short codes from API, else UUID (`unitId` / `id`). */
export function getUnitHeadingLabel(unit) {
  if (!unit) return "—";
  const explicit = String(
    unit.shortUnitId ??
      unit.unit_short_id ??
      unit.short_unit_id ??
      unit.unit_code ??
      unit.external_unit_id ??
      ""
  ).trim();
  if (explicit) return explicit;
  const legacy = getDisplayUnitId(unit);
  if (legacy && legacy !== "—") return legacy;
  return String(unit.unitId ?? unit.id ?? "").trim() || "—";
}

/** Room Map / Belegungskalender: second line under short ID (full address, not city-only). */
export function getUnitAddressSubtitle(unit) {
  if (!unit) return "—";
  const line1 = String(unit.address_line1 ?? unit.street ?? "").trim();
  const pc = String(unit.postal_code ?? unit.zip ?? "").trim();
  const ort = String(unit.city ?? unit.place ?? "").trim();
  let composed = "";
  if (line1) {
    const tail = [pc, ort].filter(Boolean).join(" ");
    composed = tail ? `${line1}, ${tail}` : line1;
  }
  const addr = String(unit.address ?? "").trim();
  const out = composed || addr || ort;
  const s = String(out || "").trim();
  return s || "—";
}
